import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpService } from 'src/app/services/http/http.service';
import { APIResponse } from 'src/app/services/http/models/api-response';
import { environment } from 'src/environments/environment';

export interface ChatbotStatisticsSummary {
  userCount: number;
  averageQueriesPerUser: number;
  topFiles: { [key: string]: number };
  queriesByTheme: { [key: string]: number };
}

@Injectable({
  providedIn: 'root',
})
export class StatisticsService {
  private readonly apiUrl = `${environment.apiEndpoint}v1/Statistics`;
  
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient, private httpService: HttpService) { }

  getStatistics(fromDate: string, toDate: string, topFiles: number = 10, topCountries: number = 10) {
    const params = new HttpParams()
      .set('fromDate', fromDate)
      .set('toDate', toDate)
      .set('topFiles', topFiles.toString())
      .set('topCountries', topCountries.toString());

    return this.http
      .get<APIResponse>
      (`${this.apiUrl}/get-statistics`, { params })
      .pipe(
        map((APIResponse: APIResponse) => {
          if (APIResponse.status.success)
            return APIResponse.data;
          else this.httpService.handleErrorMessage(APIResponse.status.message);
        }),
        catchError(this.httpService.handleError)
      );
  }

  synchronizeMetrics() {
    return this.http.post<any>(
      `${this.apiUrl}/update-chatbot-statistics-daily`,
      {},
      this.httpOptions
    );
  }
}
